export default {
      id: "facebook-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#facebook",
      toString: function () {
        return this.url;
      }
    }